__turbopack_context__.v({
  "coloredText": "TemplateCountDisplay-module-scss-module__XDlmnq__coloredText",
});
